import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../nav/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Login from "../auth/Login.jsx";
import LandingScreen from "../PageLayout/Home/LandingScreen.jsx";


const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

export default function Settings() {
 



  return (
    <>
      <AuthenticatedTemplate>
        <div id="homePage" style={{ overflow: "hidden", position: "relative" }}>
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

              <div id="mainHome" style={{ overflowY: "auto" }}>
              Settings
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}
